import {
  createOrderedProjectsStore,
  OrderedProjectsContext,
} from './OrderedProjectsContext';
import { OrderedProjectList } from './OrderedProjectList';
import { useMemo } from 'react';

export function ProjectOrdersTab() {
  const store = useMemo(() => createOrderedProjectsStore(), []);

  return (
    <OrderedProjectsContext.Provider value={store}>
      <OrderedProjectList />
    </OrderedProjectsContext.Provider>
  );
}
